// This is generated.  Alter it in blockGroups/formElements/types/DropDown.js
/* eslint-disable no-unused-vars */
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      foreignNamespace,
      foreignRelation,
      dropdownDisplayProperties,
      inputDisplayProperties,
      propertyOverride,
      required,
      children = [],
    } = hNode;
    //This block tells us the foreign namespaces/relations should exist
    //and the filters will tell us about properties we'd expect to be on there
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    const subDataDictionary = merge(
      {
        [foreignNamespace]: {
          [foreignRelation]: {
            ..._partialTypeDefinition,
          },
        },
      },
      _subDataDictionary,
    );

    const { isRequired, isEditable, isOptional, schemaOptions } =
      moduleRegistration.resolveFieldFlags(required, context);

    //this block tells us about this current property
    const specs = {
      id,
      title,
      required: isRequired,
      editable: isEditable,
      optional: isOptional,
    };
    const properties = [
      ...new Set([...dropdownDisplayProperties, ...inputDisplayProperties]),
    ];
    const partialTypeDefinition = context.registerForeignKey(
      foreignNamespace,
      foreignRelation,
      properties,
      specs,
    );
    const foreignKeyPropertyName = `${foreignNamespace}:${foreignRelation}`;
    // The foreign relation still describes where the dropdown gets records from. propertyOverride
    // only changes the schema key for the saved foreign key so domain rules can depend on a stable field.
    const key = propertyOverride || foreignKeyPropertyName;
    if (propertyOverride && partialTypeDefinition[foreignKeyPropertyName]) {
      partialTypeDefinition[key] =
        partialTypeDefinition[foreignKeyPropertyName];
      delete partialTypeDefinition[foreignKeyPropertyName];
      partialTypeDefinition[key]['x-propertyName'] = key;
    }
    if (partialTypeDefinition[key]) {
      const schema = partialTypeDefinition[key];
      schema['x-dropdownDisplayProperties'] = dropdownDisplayProperties;
      schema['x-inputDisplayProperties'] = inputDisplayProperties;
      Object.assign(schema, schemaOptions);
    }
    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'DropDown',
  module.exports,
);
